import { useState } from "react"
import Layout from "../../sections/Layout"
import { NormalUserContainer } from "../../styleComponents/NormalUserStyle"
import { useEffect } from "react";
import { Avatar, Button, Card, Spinner } from "@chakra-ui/react";
import StatusShow from "../../sections/StatusShow";
import Moment from "react-moment";
import { HomeContainer } from "../../styleComponents/HomeStyle";
import Axios from "../../utils/httpClient";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { IMG_URL } from "../../utils/api";
import RectorIncentive from "../../sections/RectorIncentive";
import { useSelector } from "react-redux";
import { formatFullName, formatDisplayName } from "../../utils/nameFormatter";

const Users = () => {
    const {user} = useSelector(s=>s);
    let [searchParams, setSearchParams] = useSearchParams();
    const [users, setUsers] = useState([]);
    const [rector_incentive_modal, setRector_incentive_modal] = useState({});
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        getApps()
    }, [])
    const getApps = () => {
        setLoading(true);
        Axios().get(`api/v1/account/user-results/${
            searchParams.get('partition')?`?partition=${searchParams.get('partition')}`:''
        }`).then(res=>{
            setUsers(res?.data??[])
        }).catch(e=>{
        }).finally(()=>{
            setLoading(false);
        })
    }
    return(<>
        <Layout>
            <HomeContainer>
                <NormalUserContainer>
                    <div className="apps">
                        <div className="head">
                            <h1>Hodimlar ({users.length} ta)</h1>
                        </div>
                        {loading?<div>
                            <Card className="loading_target">
                                <Spinner  size='lg'
                                    thickness='4px'
                                    speed='0.65s'
                                    emptyColor='gray.200'
                                    color='rgb(34, 195, 94)'
                                />
                            </Card>
                        </div>:<>
                        {users.map((item, index)=>(
                            <div key={index}>
                                <Card className="user_card">
                                    <div className="user history_user">
                                        <Avatar size='md'  name={formatDisplayName(item?.first_name, item?.last_name)} src={IMG_URL+ item?.avatar??''} />
                                        <div className="user_info">
                                            <div className="name">{formatFullName(item?.first_name, item?.last_name, item?.middle_name) || 'Noma\'lum'}</div>
                                            <div className="position">{item?.position??''} ({item?.partition__name??''})</div>
                                        </div>
                                    </div> 
                                    <div>
                                        <div className="ball">{item?.ball??0} Ball</div>
                                        {user?.role===4?<div>
                                            <Button colorScheme='messenger' type='button'
                                                onClick={()=>{setRector_incentive_modal({id: item?.id, user: item?.id})}}
                                            >
                                                Rektor Rag'batlantirishi
                                            </Button>
                                        </div>:''}
                                    </div>
                                </Card>
                            </div>
                        ))}</>}
                    </div>
                </NormalUserContainer>
            </HomeContainer>
        </Layout>
        <RectorIncentive 
            users={users}
            setUsers={setUsers}
            obj={rector_incentive_modal} 
            onClose={()=>setRector_incentive_modal({})}
        />
    </>)
}
export default Users;